export default "__VITE_ASSET__BZtHO8f0__"